import { render, staticRenderFns } from "./GoogleAuth.vue?vue&type=template&id=11988737&scoped=true"
import script from "./GoogleAuth.vue?vue&type=script&lang=js"
export * from "./GoogleAuth.vue?vue&type=script&lang=js"
import style0 from "./GoogleAuth.vue?vue&type=style&index=0&id=11988737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11988737",
  null
  
)

export default component.exports